import React from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import * as styles from './ModalStep.module.scss';

export default function ModalStep({ className, onClose, title, block, ...rest }) {
  const Component = require(`../../../blocks/${block}`).default;

  return (
    <div className={cn(styles.stepWrapper, className)}>
      <Title tag="h4" className={styles.title}>
        {title}
      </Title>
      <div className={styles.scrollArea}>
        <Component {...rest} inModal />
      </div>
    </div>
  );
}
